export const VenueRegistrationQuestionTypes = {
	VenueSelection: 'venueSelection',
	VenueRegistrationVenueSearch: 'venueRegistrationVenueSearch',
	OrganisationAddressSearch: 'organisationAddressSearch',
	DeliveryAddressSearch: 'deliveryAddressSearch',
	Checkbox: 'checkbox',
	ContactRoles: 'contactRoles',
	PaymentOptions: 'paymentOptions',
	SelectedContactSummary: 'selectedContactSummary',
	EditContactSummary: 'editContactSummary',
	AddNewContact: 'addNewContact',
	ManualContactCard: 'manualContactCard',
	PackageCard: 'packageCard',
	CostSummary: 'costSummary',
	RegistrationLegalConfirm: 'registrationLegalConfirm',
	TextInput: 'textInput',
	InsuranceAlertSnackbar: 'insuranceAlertSnackbar',
	InsuranceRiskAssessment: 'insuranceRiskAssessment'
};
